import Swiper, {Autoplay, EffectCoverflow, EffectFade, Navigation, Pagination} from 'swiper';
import GLightbox from "glightbox";

document.addEventListener("DOMContentLoaded", function (event) {

    // INIT MENUBUTTON
    const menu_button = document.querySelector('[data-behaviour="toggle-menu"]');
    menu_button.addEventListener('click', () => {
        document.body.classList.toggle('body--show');
    })

    // INIT LIGHTBOX
    const lightbox = GLightbox({
        selector: '[data-gallery="gallery"]',
        touchNavigation: true,
        loop: true,
    });
    lightbox.on('open', () => {

    });
    lightbox.on('slide_after_load', (data) => {
        const slideNode = data.slideNode;

        initSwiper('[data-behaviour="lightbox-swiper"]', slideNode);

        const prevbtn = slideNode.querySelector('[data-behaviour="lightbox-swiper_prev"]');
        prevbtn.addEventListener('click', () => {
            lightbox.prevSlide();
        });

        const nextbtn = slideNode.querySelector('[data-behaviour="lightbox-swiper_next"]');
        nextbtn.addEventListener('click', () => {
            lightbox.nextSlide();
        });

        const closebtn = slideNode.querySelector('[data-behaviour="lightbox-swiper_close"]');
        closebtn.addEventListener('click', () => {
            lightbox.close();
        });
    });





    const swipers = [];

    const initSwiper = (selector, context) => {
        const sliders = context.querySelectorAll(selector);
        sliders.forEach(function (slider) {
            const autoSwiper = slider.classList.contains('swiper--auto');
            const swiper = new Swiper(slider, {
                // configure Swiper to use modules
                modules: [Pagination, Navigation, Autoplay, EffectFade],
                effect: 'slide',
                fadeEffect: {
                    crossFade: true
                },
                direction: 'horizontal',
                loop: true,

                autoplay: autoSwiper ? {
                    delay: 5000,
                } : false,

                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },

                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true,
                },
            });

            swipers.push(swiper);
        });
    }
    initSwiper('[data-behaviour="swiper"]', document);


    //Sticky Header for mobile
    const numSteps = 20.0;

    let boxElement = document.querySelector("#headerArea");
    let prevRatio = 0.0;

    // Set things up
    window.addEventListener(
        "load",
        (event) => {
            boxElement = document.querySelector("#headerArea");

            createObserver();
        },
        false,
    );

    function createObserver() {
        let observer;

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: buildThresholdList(),
        };

        observer = new IntersectionObserver(handleIntersect, options);
        observer.observe(boxElement);
    }

    function buildThresholdList() {
        let thresholds = [];
        let numSteps = 20;

        for (let i = 1.0; i <= numSteps; i++) {
            let ratio = i / numSteps;
            thresholds.push(ratio);
        }

        thresholds.push(0);
        return thresholds;
    }

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > prevRatio) {
            entry.target.classList.remove("header--hide");
            } else {
            entry.target.classList.add("header--hide");
            }

            prevRatio = entry.intersectionRatio;
        });
    }

});
